import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { BaseRespone } from 'src/app/models/common.response';
import { environment } from 'src/environments/environment';
import { AbhaAuditAcquisitionRequest, AbhaCareContext, AbhaEnrolmentResult, AbhaEnrolRequest, AbhaAcquisitionMethod, AbhaOtpResult } from './iabha-info';

@Injectable({ providedIn: 'root' })
export class AbhaService {

  constructor(private _httpClient: HttpClient) { }

  requestOtp(aadhaarNumber: string): Observable<BaseRespone<AbhaOtpResult>> {
    return this._httpClient.post<BaseRespone<AbhaOtpResult>>(`${environment.baseURl}/Abha/request-otp`, { aadhaarNumber }).pipe(
      catchError((error) => {
        return of(error.error);
      })
    );
  }

  enrolByAadhaar(request: AbhaEnrolRequest): Observable<BaseRespone<AbhaEnrolmentResult>> {
    return this._httpClient.post<BaseRespone<AbhaEnrolmentResult>>(`${environment.baseURl}/Abha/enrol`, request).pipe(
      catchError((error) => {
        return of(error.error);
      })
    );
  }

  requestLoginOtp(abhaNumber: string, otpSystem: string): Observable<BaseRespone<AbhaOtpResult>> {
    return this._httpClient.post<BaseRespone<AbhaOtpResult>>(`${environment.baseURl}/Abha/login-request-otp`, { abhaNumber, otpSystem }).pipe(
      catchError((error) => {
        return of(error.error);
      })
    );
  }

  verifyLoginOtp(txnId: string, otp: string, otpSystem: string, patientId?: number, acquisitionMethod?: AbhaAcquisitionMethod): Observable<BaseRespone<AbhaEnrolmentResult>> {
    return this._httpClient.post<BaseRespone<AbhaEnrolmentResult>>(`${environment.baseURl}/Abha/login-verify`, { txnId, otp, otpSystem, patientId, acquisitionMethod }).pipe(
      catchError((error) => {
        return of(error.error);
      })
    );
  }

  auditAcquisition(request: AbhaAuditAcquisitionRequest): Observable<BaseRespone<boolean>> {
    return this._httpClient.post<BaseRespone<boolean>>(`${environment.baseURl}/Abha/audit-acquisition`, request).pipe(
      catchError((error) => {
        return of(error.error);
      })
    );
  }

  linkCareContext(request: { opdId?: number; ipdId?: number }): Observable<BaseRespone<AbhaCareContext>> {
    return this._httpClient.post<BaseRespone<AbhaCareContext>>(`${environment.baseURl}/Abha/link-care-context`, request).pipe(
      catchError((error) => {
        return of(error.error);
      })
    );
  }

  getCareContexts(request: { opdId?: number; ipdId?: number; patientId?: number }): Observable<BaseRespone<AbhaCareContext[]>> {
    return this._httpClient.get<BaseRespone<AbhaCareContext[]>>(`${environment.baseURl}/Abha/care-contexts`, { params: this.buildParams(request) }).pipe(
      catchError((error) => {
        return of(error.error);
      })
    );
  }

  private buildParams(request: { opdId?: number; ipdId?: number; patientId?: number }): Record<string, string> {
    const params: Record<string, string> = {};
    if (request.opdId) {
      params['opdId'] = String(request.opdId);
    }

    if (request.ipdId) {
      params['ipdId'] = String(request.ipdId);
    }

    if (request.patientId) {
      params['patientId'] = String(request.patientId);
    }

    return params;
  }
}
